import { defineStore } from 'pinia';
import { useConnectionStore } from '@/stores/connection';
import { API } from '@vp/common';
import { LoadingState } from '@/util/LoadingState';

type User = API.UserApi.User.User;

interface UserState {
  user?: User;
  userLoading: LoadingState;
  userSaving: LoadingState;
}

export const useUsersStore = defineStore('usersStore', {
  state: (): UserState => ({
    user: undefined,
    userLoading: LoadingState.UNKNOWN,
    userSaving: LoadingState.UNKNOWN,
  }),

  actions: {
    async fetchUser(userId: number) {
      const connectionStore = useConnectionStore();
      const apiClient = connectionStore.apiClient!;
      this.userLoading = LoadingState.LOADING;

      try {
        this.user = await API.UserApi.Api.fetchUser(apiClient, userId);
        this.userLoading = LoadingState.DONE;
      } catch (e) {
        this.userLoading = LoadingState.ERROR;
        throw e;
      }
    },
    async saveUser(saveUserPalyoad: User) {
      const connectionStore = useConnectionStore();
      const apiClient = connectionStore.apiClient!;
      this.userSaving = LoadingState.LOADING;

      try {
        const { user, errors } = await API.UserApi.Api.saveUser(apiClient, saveUserPalyoad);

        if (errors) {
          this.userSaving = LoadingState.ERROR;
          return { errors };
        }
        this.userSaving = LoadingState.DONE;
        return { user };
      } catch (e) {
        this.userSaving = LoadingState.ERROR;
        throw e;
      }
    },
  },
});
